import { Link } from "react-router-dom";
import { Spinner } from "../../../shared";
import { useConfig } from "../../../hooks";
import { getProductTerminology } from "../../../constants/product-terminology";
import { useGetJobsQuery } from "../../../redux/services/jobs/jobsApi";
import { JobWorkspaceFrame } from "./Frame";
import { sentenceLabel } from "./jobWorkspaceModel";
import { WorkspaceCard } from "./ui";

/**
 * @param {object|undefined} result
 * @returns {Array<object>}
 */
function jobsFromResult(result) {
  if (Array.isArray(result?.jobs)) return result.jobs;
  if (Array.isArray(result?.docs)) return result.docs;
  return [];
}

/**
 * Entry list for the jobs v2 workspace.
 * Opens the detail page. Hidden unless `jobs.v2.enabled` is on.
 * @returns {JSX.Element}
 */
export function JobWorkspaceIndex() {
  const { appType } = useConfig();
  const terms = getProductTerminology(appType);
  const { data, isLoading, isError } = useGetJobsQuery({ page: 1, limit: 20 });
  const jobs = jobsFromResult(data);

  return (
    <JobWorkspaceFrame
      crumbs={[{ label: "Operations", to: "/" }, { label: terms.jobPlural }]}
    >
      <WorkspaceCard>
        <div className="flex items-center justify-between p-5">
          <h1 className="text-[16px] font-semibold leading-normal text-[#202b33]">
            {terms.jobPlural}
          </h1>
        </div>
        {isLoading ? (
          <div className="flex justify-center py-10">
            <Spinner />
          </div>
        ) : null}
        {!isLoading && isError ? (
          <p className="px-5 pb-5 text-[12px] leading-normal text-[#6e7b84]">
            Jobs could not be loaded.
          </p>
        ) : null}
        {!isLoading && !isError && jobs.length === 0 ? (
          <p className="px-5 pb-5 text-[12px] leading-normal text-[#6e7b84]">
            No {terms.jobPlural.toLowerCase()} yet.
          </p>
        ) : null}
        <ul>
          {jobs.map((job) => (
            <li key={job._id} className="border-t border-[#e2e7ea]">
              <Link
                to={`/jobs/v2/${job._id}`}
                className="flex items-center justify-between gap-4 px-5 py-4 hover:bg-[#f7f9fa]"
              >
                <span className="min-w-0">
                  <span className="block truncate text-[13px] font-medium leading-[1.4] text-[#202b33]">
                    {job.jobId || job.loadNumber || terms.job}
                  </span>
                  <span className="text-[11px] font-normal leading-normal text-[#6e7b84]">
                    {job.loadNumber ? `Load ${job.loadNumber}` : "Load not provided"}
                  </span>
                </span>
                <span className="shrink-0 text-[12px] font-normal leading-normal text-[#6e7b84]">
                  {job.status ? sentenceLabel(job.status) : "Not provided"}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </WorkspaceCard>
    </JobWorkspaceFrame>
  );
}

export default JobWorkspaceIndex;
